import { useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { phoneRegExp } from "constants/constants";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  KelasLiveCMBFormValues,
  KelasLiveCMBStages
} from "../kelas-live-cmb.types";
import { useBoolean } from "hooks/use-boolean/use-boolean";
import trackEvent from "services/mixpanel/mixpanel";
import { kelasLiveEvents } from "services/mixpanel/kelas-live-events";

const FormSchema = yup.object().shape({
  phoneNumber: yup
    .string()
    .required("Mohon lengkapi nomor HP kamu")
    .matches(phoneRegExp, "Masukin nomor HP yang aktif, ya.")
    .min(8, "Masukin minimal 8 angka, ya.")
    .max(13, "Hmm... nomornya kepanjangan, nih.")
});

export const useKelasLiveCMBForm = ({
  handleCMBStage,
  requestCallBack,
  onClose
}: {
  handleCMBStage: (stage: KelasLiveCMBStages) => void;
  requestCallBack: (phoneNumber: string) => Promise<boolean>;
  onClose: () => void;
}) => {
  const {
    control,
    handleSubmit,
    formState: { isValid }
  } = useForm<KelasLiveCMBFormValues>({
    defaultValues: {
      phoneNumber: ""
    },
    resolver: yupResolver(FormSchema),
    mode: "onChange"
  });
  const [isLoading, setIsLoading] = useBoolean(false);

  useEffect(() => {
    trackEvent({
      eventName: kelasLiveEvents.writeNumHereBottomSheetViewed
    });
  }, []);

  const sendDroppedOffEvent = () => {
    trackEvent({
      eventName: kelasLiveEvents.numBottomSheetDroppedOff
    });
  };

  const handleBack = () => {
    handleCMBStage(KelasLiveCMBStages.SHOW_ACK_STAGE);
    sendDroppedOffEvent();
  };

  const handleClose = () => {
    onClose();
    sendDroppedOffEvent();
  };

  const onSubmit: SubmitHandler<KelasLiveCMBFormValues> = async ({
    phoneNumber
  }) => {
    setIsLoading.on();
    trackEvent({
      eventName: kelasLiveEvents.sendNumBottomSheetClicked
    });
    const success = await requestCallBack(phoneNumber);
    if (success) {
      handleCMBStage(KelasLiveCMBStages.SHOW_ACK_STAGE);
    }
  };
  return {
    control,
    handleSubmit,
    isValid,
    onSubmit,
    handleBack,
    handleClose,
    isLoading
  };
};
